import { ValidateAny } from "./ValidateAny";
import { Message, getMessage } from "./helpers";

// EmailRegex taken from https://emailregex.com/
// eslint gives an error based on the characters < 0x1F, these are part of the regex as specified.
// eslint-disable-next-line
const EmailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/ig;

function validateCheckSum(iban: string) {
    // Move country + checksum to end
    let value = iban.slice(4) + iban.slice(0, 4);

    // Replace letters by numbers
    value = value.replace(/[A-Z]/ig, (char: string) => (char.charCodeAt(0) - 55).toString());

    let checksum = 0;
    for (let offset = 0; offset < value.length; offset += 7) {
        const fragment = String(checksum) + value.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
    }

    return checksum === 1;
};

function ibanHasError(value: string): false | 'format' | 'nl' | 'checksum' {
    value = (value || '').replace(/\s+/g, '').toUpperCase();

    if (value === '')
        return false;

    if (value.match(/^nl/i) && !value.match(/^NL[0-9]{2}[A-Z]{4}[0-9]{10}$/ig)) {
        return 'nl';
    }
    else if (!value.match(/^[A-Z]{2}[0-9]{2}[A-Z0-9]{5,30}$/ig)) {
        return 'format';
    }

    if (!validateCheckSum(value))
        return 'checksum';

    return false;
}
export class ValidateString<TRoot> extends ValidateAny<string, TRoot> {
    public length(min: number, max: number, message?: Message) {
        this.add((value: string) => {
            if (!value)
                return null;
            if (typeof (max) !== 'number' && value.length < min)
                return { message: getMessage(this.name, message, `${this.name} moet minimaal ${min} tekens lang zijn.`) };
            if (typeof (min) !== 'number' && value.length > max)
                return { message: getMessage(this.name, message, `${this.name} mag maximaal ${max} tekens lang zijn.`) };
            if (value.length < min || value.length > max)
                return { message: getMessage(this.name, message, `${this.name} moet tussen de ${min} en ${max} tekens lang zijn.`) };

            return null;
        });
        return this;
    }

    public regex(format: RegExp, message?: Message) {
        this.add((value: string) => {
            if (!value || new RegExp(format).test(value))
                return null;

            return { message: getMessage(this.name, message, `${this.name} bevat een ongeldige waarde`) };
        });
        return this;
    }

    public formatEmail(message?: Message) {
        return this.regex(EmailRegex, message || ((name) => `${name} bevat een ongeldig email adres`));
    }
    public iban(message?: Message) {
        this.add((value: string) => {
            if (!value)
                return null;

            const error = ibanHasError(value);
            if (!error)
                return null;
            else if (error === 'checksum')
                return { message: 'Het controle getal in het IBAN nummer is onjuist' };
            else if (error === 'nl')
                return { message: 'De opgegeven waarde is geen geldig nederlands IBAN nummer' };
            else
                return { message: 'De opgegeven waarde is geen geldig IBAN nummer' };
        });
        return this;
    }
}
